import { isToday } from './index'

export const kFormatter = (num, fraction = 2) =>
  num > 999 ? `${(num / 1000).toFixed(fraction)}k` : num

export const title = (value, replacer = ' ') => {
  if (!value) return ''
  const str = value.toString()

  const arr = str.split(replacer)
  const capitalizedArray = []
  arr.forEach(word => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalizedArray.push(capitalized)
  })

  return capitalizedArray.join(' ')
}

export const avatarText = value => {
  if (!value) return ''
  let unSpaceValue
  if (value.slice(-1) === ' ') {
    unSpaceValue = value.slice(0, -1)
  } else {
    unSpaceValue = value
  }
  const nameArray = unSpaceValue.split(' ').slice(0, 2)
  if (nameArray.length === 1) {
    return unSpaceValue.slice(0, 1).toUpperCase() + unSpaceValue.slice(1, 2).toLowerCase()
  }

  return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
}

/**
 * Format and return date in Humanize format
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: 'short', day: 'numeric', year: 'numeric' },
) => {
  if (!value) return value

  return new Intl.DateTimeFormat('id-ID', formatting).format(new Date(value))
}

export const formatCurrency = (value, currency = 'IDR') => {
  if (!value) return value
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  })

  return formatter.format(value)
}

/**
 * Return short human friendly month representation of date
 * Can also convert date to only time if date is of today (Better UX)
 * @param {String} value date to format
 * @param {Boolean} toTimeForCurrentDay Shall convert to time if day is today/current
 */
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric', hour12: false }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric', hour12: false }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// Strip all the tags from markup and return plain text
export const filterTags = value => value.replace(/<\/?[^>]+(>|$)/g, '')

export const ellipsis = (text, length = 24) => {
  if (!text) return ''

  return text.length >= length ? `${text.substring(0, length)}...` : text
}

export const isNumber = value => /^\d+$/.test(value)

export const stringToSlug = text =>
  text
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')

export const formatCreditCard = maskedNumber => `****-****-****-${maskedNumber.split('-')[1]}`
